const options = {
  5: "bg-sky-900/5",
  10: "bg-sky-900/10",
  25: "bg-sky-900/25",
  50: "bg-sky-900/50",
  75: "bg-sky-900/75",
  90: "bg-sky-900/90",
  100: "bg-sky-900",
};

const from = {
  5: "from-sky-900/5",
  10: "from-sky-900/10",
  25: "from-sky-900/25",
  50: "from-sky-900/50",
  75: "from-sky-900/75",
  90: "from-sky-900/90",
  100: "from-sky-900",
};

export default function getBackgroundSky900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
